import { ReactNode } from 'react';
import { OverlayArrow, Tooltip as AriaTooltip } from 'react-aria-components';
import type { TooltipProps as AriaTooltipProps } from 'react-aria-components';



interface TooltipProps extends Omit<AriaTooltipProps, 'children'> {
	children: ReactNode;
	isInvalid?: boolean;
  }


export function Tooltip(props: TooltipProps) {
	const { children, className, isInvalid, ...otherProps} = props;
	return (
		<AriaTooltip
			{...otherProps}
			className={`react-aria-Tooltip${isInvalid ? ' invalid' : ''}${className ? ` ${className}` : ''}`}>
			
			<OverlayArrow>
				<svg width={8} height={8} viewBox="0 0 8 8">
					<path d="M0 0 L4 4 L8 0" />
				</svg>
			</OverlayArrow>
			
			{children}
		
		</AriaTooltip>
	)
}